<!-- Renders nothing when the caller is unrestricted, so call sites need no v-if. -->
<template>
  <v-alert
    v-if="anonymousHistoryDays"
    type="info"
    variant="tonal"
    density="compact"
    class="anonymous-notice mb-4"
  >
    <div class="notice-in">
      <span>
        Ohne Anmeldung sind nur die letzten
        <strong>{{ anonymousHistoryDays }} Tage</strong> sichtbar.
      </span>
      <v-btn size="small" variant="text" prepend-icon="mdi-login" @click="signIn()">
        Anmelden
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
import { mapState } from 'vuex'
import SignInMixin from '@/mixins/SignInMixin'

export default {
  name: 'AnonymousNotice',

  mixins: [SignInMixin],

  computed: {
    ...mapState({
      anonymousHistoryDays: state => state.anonymousHistoryDays,
    }),
  },
};
</script>

<style scoped>
.notice-in {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  align-items: center;
  justify-content: space-between;
}
</style>
